import { mergeAllOfSchemas as e } from "./merge-all-of-schemas.js";
import { getResolvedRef as t } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { resolve as n } from "@scalar/workspace-store/resolve";
//#region src/schema/helpers/partition-all-of-compositions.ts
var r = ["oneOf", "anyOf"], i = (e, a, o) => {
	let s = t(e);
	if (typeof s == "boolean") {
		a.push({
			kind: "boolean",
			schema: n.schema(s)
		});
		return;
	}
	let { allOf: c, oneOf: l, anyOf: u, not: d, if: f, then: p, else: m, ...h } = n.schema(e);
	Object.keys(h).length > 0 && a.push({
		kind: "object",
		schema: h
	});
	for (let e of r) {
		let t = e === "oneOf" ? l : u, n = Array.isArray(t) && t.some((e) => {
			let t = e && typeof e == "object" && "$ref" in e ? e.$ref : void 0;
			return typeof t == "string" && o.has(t);
		});
		Array.isArray(t) && t.length > 0 && a.push({
			kind: "choice",
			composition: e,
			value: { [e]: t },
			inheritedSelection: n
		});
	}
	if (Array.isArray(c)) {
		for (let e of c) if (typeof e == "boolean" || e && typeof e == "object") {
			let t = n.schema(e).$ref;
			if (typeof t == "string") {
				if (o.has(t)) continue;
				i(e, a, new Set(o).add(t));
			} else i(e, a, o);
		}
	}
}, a = (t) => {
	if (!t) return { segments: [] };
	let { allOf: r, oneOf: a, anyOf: o, not: s, if: c, then: l, else: u, ...d } = t;
	if (!Array.isArray(r)) return { segments: [{
		kind: "object",
		schema: t
	}] };
	let f = [];
	Object.keys(d).length > 0 && f.push({
		kind: "object",
		schema: d
	});
	let p = "$ref" in t ? t.$ref : void 0, m = new Set(typeof p == "string" ? [p] : []);
	for (let e of r) if (typeof e == "boolean" || e && typeof e == "object") {
		let t = n.schema(e).$ref;
		i(e, f, typeof t == "string" ? new Set(m).add(t) : m);
	}
	let h = [], g = [], _ = 0, v = () => {
		if (g.length === 0) return;
		let t = g.length === 1 ? g[0] : e({ allOf: g });
		h.push({
			kind: "object",
			schema: t
		}), g = [];
	};
	for (let e of f) e.kind === "object" ? g.push(e.schema) : e.kind === "boolean" ? (v(), h.push({
		kind: "object",
		schema: e.schema
	})) : e.inheritedSelection ? _++ : (v(), h.push({
		kind: "choice",
		composition: e.composition,
		value: e.value,
		choiceIndex: _++
	}));
	return v(), { segments: h };
};
//#endregion
export { a as partitionAllOfCompositions };

//# sourceMappingURL=partition-all-of-compositions.js.map